module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"required":"Required field"},"de":{"required":"Pflichtfeld"}}')
  delete Component.options._Ctor
}
